module.exports = __webpack_public_path__ + "img/about_history_metamo_card.a982ccbd.jpg";